import Constants from 'lib/Constants';
import ApiService from 'services//ApiService';
import { getLogger } from 'utils/logging';
import { clone } from 'utils/ObjectUtils';
import AppService from './AppService';

const { log, warn } = getLogger('CurrencyService', { color: 'green', enabled: false });

class CurrencyService {

    private store: CacheStore;

    public getExchangeRates = async () => {
        try {
            let rates = await AppService.getAppData(Constants.EXCHANGE_RATES);
            if (rates) {
                let d = moment(rates.date);
                let today = moment();
                if (d.isSame(today, 'day')) {
                    return rates.rates;
                }
            }

            let r = await ApiService.get(`/exchange-rates`);
            if (r.success) {
                await AppService.setAppData(Constants.EXCHANGE_RATES, r.rates);
                return r.rates.rates;
            } else {
                throw r.error;
            }
        } catch (e) {
            throw e;
        }
    }

    convertCurrency(amount, from, to, rates) {
        try {
            let p = parseFloat(amount);
            from = from.toLowerCase();
            to = to.toLowerCase();

            if (!rates) {
                console.log('WARNING: Exchange rates not given for currency conversion.', amount, from, to);
                return amount;
            }

            // convert amount to base usd first:
            if (from != 'usd') {
                if (!rates[from]) {
                    throw "From currency is not supported for conversion: " + from;
                }
                log("Converting currency from: " + from, rates[from].inverseRate, p, '=', p * rates[from].inverseRate);
                p = p * rates[from].inverseRate;
            }

            // convert to target currency if not USD already
            if (from != to && to != 'usd') {
                if (!rates[to]?.rate) {
                    throw "To currency is not supported for conversion: " + to;
                }
                log("Converting currency to: " + to, rates[to]?.rate, p, '=', p * rates[to]?.rate);
                p = p * rates[to]?.rate;
            }

            if (Number.isNaN(p)) {
                console.log('WARNING: Currency conversion failed for: ', amount, 'from:', from, 'to:', to);
                console.trace();
                return 0;
            }

            return p;
        } catch (e) {
            console.log('Exception converting currency, from: ', from, 'to: ', to, 'amount: ', amount, 'error: ', e);
            throw e;
        }
    }

    // Converts all FB money values in the given dataset to the target currency.
    async convertDatasetCurrency(dataset, from, to) {
        //return dataset;

        let rates = await this.getExchangeRates();

        if (!Array.isArray(dataset)) {
            console.log('Dataset is not array, cannot convert currencies:', dataset)
            return dataset;
        }

        const _convertActionValues = (a) => {
            if (a['value']) a['value'] = this.convertCurrency(a['value'], from, to, rates);
            if (a['1d_view']) a['1d_view'] = this.convertCurrency(a['1d_view'], from, to, rates);
            if (a['7d_click']) a['7d_click'] = this.convertCurrency(a['7d_click'], from, to, rates);
            if (a['28d_click']) a['28d_click'] = this.convertCurrency(a['28d_click'], from, to, rates);
            return a;
        }

        const _isPurchase = (a) => {
            if (!a.action_type) return false;
            return a.action_type == 'purchase'; //.indexOf('purchase') >= 0;
        }

        // Converts all known properties for any object instance.
        const _convertObjectProps = (i) => {
            if (i.spend) {
                i.spend = this.convertCurrency(i.spend, from, to, rates);
            }

            // if (i.actions) {
            //     i.actions.forEach(a => _isPurchase(a) ? _convertActionValues(a) : a);
            // }

            // if (i.action_values) {
            //     i.action_values.forEach(a => _isPurchase(a) ? _convertActionValues(a) : a);
            // }

            // if (i.unique_actions) {
            //     i.unique_actions.forEach(a => _isPurchase(a) ? _convertActionValues(a) : a);
            // }

            // if (i.cost_per_action_type) {
            //     i.cost_per_action_type.forEach(a => _isPurchase(a) ? _convertActionValues(a) : a);
            // }

            // if (i.cost_per_unique_action_type) {
            //     i.cost_per_unique_action_type.forEach(a => _isPurchase(a) ? _convertActionValues(a) : a);
            // }

            // convert each instance as well:
            if (i.instances) {
                i.instances.forEach(di => {
                    _convertObjectProps(di);
                });
            }
        }

        log('converting fb insights currencies:', from, rates[from.toLowerCase()], 'to:', to, rates[to.toLowerCase()], clone(dataset));

        dataset.forEach(ds => {
            if (!ds.data) return;
            if (!Array.isArray(ds.data)) {
                // if it's wrapped insights data:
                if (ds.data.adInsights && ds.data.campaignInsights) {
                    //console.log('>> Converting insights: ', ds.id, clone(ds.data.adInsights));//, ds.data.adInsights);

                    Object.keys(ds.data.adInsights).forEach(k => {
                        let ai = ds.data.adInsights[k];
                        ai.spend = this.convertCurrency(ai.spend, from, to, rates);
                    });

                    // Object.keys(ds.data.campaignInsights).forEach(k => {
                    //     let campaigns = ds.data.campaignInsights[k];
                    //     if (Array.isArray(campaigns) && campaigns.length) {
                    //         campaigns.forEach(ci => {
                    //             ci.spend = this.convertCurrency(ci.spend, from, to, rates);
                    //         });
                    //     }
                    // });

                    //console.log('converted: ', ds.id, clone(ds.data.adInsights));//, ds.data.adInsights);
                }
                return;
            } else {
                // Otherwise process normal insights/action data:
                ds.data.forEach(d => {
                    _convertObjectProps(d);
                });

            }
        });

        return dataset;
    }

}

export default new CurrencyService();